import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';
import clsx from 'clsx';
import Slider from 'react-slick';
import Grid from '@material-ui/core/Grid';
import { content } from './constant';
import { Fade } from 'react-awesome-reveal';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Hidden from '@material-ui/core/Hidden';

import quotation from '../../../../assets/svgs/quotations.svg';

const CauroselComponent = ({ classes }) => {
  const SampleNextArrow = props => {
    const { onClick } = props;
    return (
      <Hidden xsDown>
        <IconButton
          onClick={onClick}
          className={clsx(classes.arrowIcon, classes.nextArrow)}
        >
          <ArrowForwardIosIcon fontSize='large' style={{ color: '#fff' }} />
        </IconButton>
      </Hidden>
    );
  };

  const SamplePrevArrow = props => {
    const { onClick } = props;
    return (
      <Hidden xsDown>
        <IconButton
          onClick={onClick}
          className={clsx(classes.arrowIcon, classes.prevArrow)}
        >
          <ArrowForwardIosIcon
            fontSize='large'
            style={{ color: '#fff', transform: 'rotate(180deg)' }}
          />
        </IconButton>
      </Hidden>
    );
  };

  const Slides = (data, key) => {
    return (
      <div key={key} className={classes.slides}>
        <Grid
          container
          spacing={3}
          style={{
            minHeight: '300px',
            borderRadius: '10px',
            padding: '50px 0',
          }}
          alignItems='center'
        >
          <Grid item md={5} xs={12} style={{ textAlign: 'center' }}>
            <img
              src={data.data.img}
              alt=''
              style={{ width: '80%', margin: 'auto auto 20px' }}
            />
          </Grid>
          <Grid item md={7} xs={12}>
            <img src={quotation} alt='' style={{ width: '4rem' }} />
            <p style={{ marginBottom: '30px', fontSize: '1.25rem' }}>
              {data.data.comment}
            </p>
            <p
              style={{
                fontWeight: 'bold',
                color: '#F9701F',
                margin: '0',
                fontSize: '1.5rem',
              }}
            >
              {data.data.name}
            </p>
            <p style={{ margin: '0', fontSize: '1.125rem' }}>
              {data.data.role}
            </p>
          </Grid>
        </Grid>
      </div>
    );
  };

  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Grid
      container
      className={classes.root}
      justify='center'
      alignItems='center'
    >
      <Grid item xs={12} md={10}>
        <Fade duration='1500' direction='up' triggerOnce>
          <h1 className={clsx(classes.header1, classes.spacingBottom)}>
            Apa yang pengguna kami katakan tentang Ngamen Hub?
          </h1>
        </Fade>
      </Grid>
      <Grid item md={9} xs={12}>
        <Fade duration='1500' direction='up' triggerOnce>
          <Slider {...settings}>
            {content.map((v, i) => (
              <Slides data={v} key={i} />
            ))}
          </Slider>
        </Fade>
      </Grid>
    </Grid>
  );
};

export default CauroselComponent;
